import React from "react";

import Top from './images/icons/up.png'
import Egypt from './images/icons/egypt.png'
import Dark from './images/icons/moon.png'

import ML from './images/elements/Locations/Mosque Left.png'
import MR from './images/elements/Locations/Mosque Right.png'
import Cloud from './images/elements/Locations/Cloud.png'
import Cloud2 from './images/elements/Locations/Cloud2.png'


const Locations = () => (
  <div className="locationpage">
    <div className="mainsite">
      <img id="item1" src={ML} alt="Mosque" style={{ float: "left" }} />
      <img id="item2" src={MR} alt="Mosquee" style={{ float: "right" }} />
      <img id="item3" src={Cloud} alt="Cloud" style={{ top: "auto" }} />
      <img id="item4" src={Cloud2} alt="Cloud2" style={{ position: "relative", top: "48vh", float: "right" }} />
      <div className="img-text">
        <h1> Ten Tips for each day of Dhul Hijjah </h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
        </p>
        <br />
        <button>Learn More</button>
      </div>
    </div>

    <div className="boxes">
        <center>
      <div className="box" style={{ display: "flex", width: "650px", height: "80px" }}>
      <div className="textbox6">
        <h2>Rose Smith</h2>
        <h2>⭑⭑⭑⭑⭑</h2>
        </div>
        <div><h3>┃</h3></div>
        <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse tristique gravida. Risus commodo viverra maecenas.
        </p>
      </div>

      <div className="box" style={{ display: "flex", width: "650px", height: "80px" }}>
      <div className="textbox6">
        <h2>Anna Doe</h2>
        <h2>⭑⭑⭑⭑⭑</h2>
        </div>
        <div><h3>┃</h3></div>
        <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse tristique gravida. Risus commodo viverra maecenas.
        </p>
      </div>

      <div className="box" style={{ display: "flex", width: "650px", height: "80px" }}>
        <div className="textbox6">
        <h2>John Green</h2>
        <h2>⭑⭑⭑⭑⭑</h2>
        </div>
        <div><h3>┃</h3></div>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse tristique gravida.
          Risus commodo viverra maecenas.
        </p>
      </div>
      </center>
    </div>

    <div className="features">
    <a href="#"> <img src={Top} width="40" style={{ border: 'none' }} id="toTop" className="test"/></a>
    <a href="#"> <img src={Egypt} width="40"/></a>
    <a href="#"> <img src={Dark} width="40"/></a>
    </div>

  </div>
);

export default Locations;